import { query } from './query'

export const homePageQuery = {
  query,
  mocks: {
    defaultData: null,
  },
}
